import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import "./nav.css"

const NavStyles = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;  

@media (min-width: 500px) {
    
    margin-top: -60px;
  }
`

const NavH1Wrapper = styled.div`
  @media (min-width: 500px) {
    background-color: white;
    padding: 0.9rem 3rem;
    border-radius: 4px 4px 0px 0px;
    margin-right: 0.5rem;
    width: auto;
    border-bottom: none;

    h1 {
      font-size: 1.6rem;
    }
  }

  padding-bottom: 1rem;
  border-bottom: 2px solid #1eaef1;
  width: 48%;
  text-align: center;

  h1 {
    margin-bottom: 0;
    font-size: 1.2rem;
  }
`

const NavLinkWrapper = styled.div`
  @media (min-width: 500px) {
    background: linear-gradient(rgb(242, 242, 242), 95%, rgb(229, 229, 229));
    padding: 0.9rem 3rem;
    border-radius: 4px 4px 0px 0px;
    width: auto;
  }

  width: 48%;
  text-align: center;

  a {
    color: inherit;
    display: block;
    font-size: 1.2rem;
    text-decoration: none;
    line-height: 1.1;
  }
`

const Nav = ({ page }) => {
  const data = useStaticQuery(graphql`
    query NavContent {
      allMarkdownRemark(filter: { frontmatter: { whichPage: { eq: "nav" } } }) {
        edges {
          node {
            frontmatter {
              resume
              resumePath
              portfolio
              portfolioPath
            }
          }
        }
      }
    }
  `)
  const {
    portfolio,
    portfolioPath,
    resume,
    resumePath,
  } = data.allMarkdownRemark.edges[0].node.frontmatter
  return (
    <nav style={{ marginBottom: `2rem` }}>
      <NavStyles id="top">
        {page === "resume" && (
          <>
            <NavH1Wrapper>
              <h1>{resume}</h1>
            </NavH1Wrapper>
            <NavLinkWrapper>
              <Link className="nav-link" to={portfolioPath}>
                {portfolio}
              </Link>
            </NavLinkWrapper>
          </>
        )}
        {page === "portfolio" && (
          <>
            <NavH1Wrapper>
              <h1>{portfolio}</h1>
            </NavH1Wrapper>
            <NavLinkWrapper style={{ marginRight: `0.5rem` }}>
              <Link className="nav-link" to={resumePath}>
                {resume}
              </Link>
            </NavLinkWrapper>
          </>
        )}
      </NavStyles>
    </nav>
  )
}

export default Nav
